import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { BerichtQueryFilterConfig, IBerichtResponse } from 'fa-kt.types';
import { BerichtService } from '../service';

@Component({
  selector: 'fa-kt-bericht-filter',
  templateUrl: './bericht-filter.component.html',
  styleUrls: ['./bericht-filter.component.css'],
})
export class BerichtFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public BerichtFilterConfig: IFilterConfig<IBerichtResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public bericht: BerichtService,
  ) {
    this.BerichtFilterConfig = BerichtQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.BerichtFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.BerichtFilterConfig[index].selections = shapes;
  }
}
